angular.module("informazioniUtili.components", [])
  .component("informazioniUtili", {
    templateUrl: "ng/components/informazioniUtili/informazioniUtili.view.html",
    bindings: {
      label: "@",
      listOfOtherLabel: '<',
      isElencoPuntato: '<',
      isNotUppercase: '<',
      clearLabelInfo: '<'
    },
    controllerAs: "informazioniUtiliCtrl",
    controller: function (
      $timeout
    ) {
      var self = this;

      self.$onInit = function () {
        self.label = self.label && self.label
          .replace(/#u#/gi, '<u>')
          .replace(/#\/u#/gi, '</u>')
          .toUpperCase();
        clearLabelInfoFn();
        $timeout(function () {
          jQuery('#labelInfoUtili').append(self.label);
        }, 100)

      }

      self.$onChanges = function (changes) {

        if (changes.label && changes.label.currentValue) {
          self.label = changes.label.currentValue
            .replace(/#u#/gi, '<u>')
            .replace(/#\/u#/gi, '</u>')
            .toUpperCase();
          $timeout(function () {
            clearLabelInfoFn();
            jQuery('#labelInfoUtili').append(self.label);
          }, 100)
        }

        if (changes.clearLabelInfo && changes.clearLabelInfo.currentValue) {
          clearLabelInfoFn();
        }
      }

      var clearLabelInfoFn = function () {
        jQuery('#labelInfoUtili').empty();
      }
    }
  });